import React from 'react'
import classNames from 'classnames'
import { Button, Portal } from '@/components/common'
import { ToastNotification as Notification } from '@/components/context/NotificationsContext/NotificationsContext'
import { Close } from '@/components/svg'
import useNotifications from '@/services/hooks/useNotifications'
import ToastNotification from '../ToastNotification'

export const ToastNotificationList = () => {
  const { notifications, removeNotification, clearNotifications } =
    useNotifications()
  const toasts = notifications.filter(
    (n) => n.type === 'toast'
  ) as Notification[]

  return (
    <Portal>
      <div
        className={classNames({
          'fixed bottom-0 left-0 z-[9999] flex transform flex-col-reverse px-4 transition-all duration-300 ease-out':
            true,
          'pointer-events-none translate-y-full': toasts.length === 0,
        })}
      >
        {toasts.map((toast) => (
          <ToastNotification
            key={toast.id}
            {...toast}
            handleRemove={() => removeNotification(toast.id)}
          />
        ))}
        {toasts.length > 1 && (
          <div className="mb-3 flex justify-end">
            <Button
              size="sm"
              onClick={() => clearNotifications('toast')}
              className="flex items-center"
            >
              <span className="leading-none">Clear All</span>
              <Close className="ml-2 mr-[-2px] mt-[-1px] h-5 w-5 text-white" />
            </Button>
          </div>
        )}
      </div>
    </Portal>
  )
}

export default ToastNotificationList
